import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class VeneerService {

  private _veneer$ = new BehaviorSubject<any>('');
  private _veneerName$ = new BehaviorSubject<any>('');
  veneerName$ = this._veneerName$.asObservable();

  hasVeneer$ = this._veneer$.pipe(
    map(ven => {
      if (!!ven) {
        return true;
      }
      return false;
    }));

  constructor() { }

  updateVeneer(key: string) {
    this._veneer$.next(key);
  }

  setVeneerName(name: string) {
    this._veneerName$.next(name);
  }

}
